const block_icons     = {
    flat_icon:    <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    enableBackground="new 0 0 512 512"
    viewBox="0 0 480 480"
  >
    <path
      xmlns="http://www.w3.org/2000/svg"
      fill="#db1d1d"
      d="M415.928 88a8 8 0 00-2.272-5.656l-80-80A7.896 7.896 0 00328 .072V0H88C74.745 0 64 10.745 64 24v432c0 13.255 10.745 24 24 24h304c13.255 0 24-10.745 24-24V88h-.072zM336 27.312L388.688 80H344a8 8 0 01-8-8V27.312zM400 456a8 8 0 01-8 8H88a8 8 0 01-8-8V24a8 8 0 018-8h232v56c0 13.255 10.745 24 24 24h56v360z"
      data-original="#000000"
    ></path>
    <path
      xmlns="http://www.w3.org/2000/svg"
      fill="#db1d1d"
      d="M144 216c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm0 32a8 8 0 110-16 8 8 0 010 16z"
      data-original="#000000"
    ></path>
    <path
      xmlns="http://www.w3.org/2000/svg"
      fill="#db1d1d"
      d="M200 232H360V248H200z"
      data-original="#000000"
    ></path>
    <path
      xmlns="http://www.w3.org/2000/svg"
      fill="#db1d1d"
      d="M144 136c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm0 32a8 8 0 110-16 8 8 0 010 16z"
      data-original="#000000"
    ></path>
    <path
      xmlns="http://www.w3.org/2000/svg"
      fill="#db1d1d"
      d="M200 152H360V168H200z"
      data-original="#000000"
    ></path>
    <path
      xmlns="http://www.w3.org/2000/svg"
      fill="#db1d1d"
      d="M144 296c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm0 32a8 8 0 110-16 8 8 0 010 16z"
      data-original="#000000"
    ></path>
    <path
      xmlns="http://www.w3.org/2000/svg"
      fill="#db1d1d"
      d="M200 312H360V328H200z"
      data-original="#000000"
    ></path>
    <path
      xmlns="http://www.w3.org/2000/svg"
      fill="#db1d1d"
      d="M144 376c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm0 32a8 8 0 110-16 8 8 0 010 16z"
      data-original="#000000"
    ></path>
    <path
      xmlns="http://www.w3.org/2000/svg"
      fill="#db1d1d"
      d="M200 392H360V408H200z"
      data-original="#000000"
    ></path>
  </svg>
}

export default block_icons;